import React from "react";
import Footer from "../../Shared/Footer/Footer";
import Banner from "../Banner/Banner";
import Navbar from "../Navbar/Navbar";
import HeaderNavbarTwo from "../../Shared/Header/HeaderNavbar/HeaderNavbarTwo";

const PageFour = () => {
  return (
    <div>
      {/* <Navbar /> */}
      <HeaderNavbarTwo />
      <Banner />
      <Footer />
    </div>
  );
};

export default PageFour;
